/* Pack Solution cart + sticky bar guards.
   1. Minimum order (variant metafield custom.minimum_order_quantity, rendered as data-moq on cart inputs):
      the minus button stops at the minimum, typed values below it snap back up (0 / remove still works),
      and checkout is blocked while any line shows the "Minimum order" warning (.cart-item__moq).
   2. Sticky add-to-cart bar: adds the quantity chosen in the main buy box (volume cards included),
      keeps its inc-VAT price in step with the selected variant, and stays hidden until the shopper
      has scrolled past the main Add to cart button. */
(function () {
  'use strict';

  // ---------- 1. Minimum order in the cart page and drawer ----------
  function moqOf(input) { return parseInt(input && input.dataset.moq, 10) || 1; }

  document.addEventListener('click', function (e) {
    var minus = e.target.closest && e.target.closest('button[name="minus"]');
    if (!minus) return;
    var input = minus.parentElement && minus.parentElement.querySelector('input[data-moq]');
    if (!input) return;
    var moq = moqOf(input);
    if (moq > 1 && parseInt(input.value, 10) <= moq) {
      e.preventDefault();
      e.stopImmediatePropagation();
      input.value = moq;
      minus.setAttribute('aria-disabled', 'true');
    }
  }, true);

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('input[data-moq]')) return;
    var v = parseInt(input.value, 10) || 0;
    var moq = moqOf(input);
    if (v > 0 && v < moq) input.value = moq; // the theme's own change handler then saves the corrected value
  }, true);

  function cartHasMoqProblem() { return !!document.querySelector('.cart-item__moq'); }

  function blockCheckout(e) {
    var btn = e.target.closest && e.target.closest('[name="checkout"], a[href="/checkout"]');
    var isCheckoutSubmit = e.type === 'submit' && e.submitter && e.submitter.name === 'checkout';
    if (!(btn || isCheckoutSubmit) || !cartHasMoqProblem()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var warn = document.querySelector('.cart-item__moq');
    if (warn) {
      warn.scrollIntoView({ behavior: 'smooth', block: 'center' });
      warn.setAttribute('tabindex', '-1');
      warn.focus({ preventScroll: true });
    }
  }
  document.addEventListener('click', blockCheckout, true);
  document.addEventListener('submit', blockCheckout, true);

  // ---------- 2. Sticky add-to-cart bar ----------
  // The sticky bar is div.sticky-atc-bar (never match by partial class names: <body> carries "sticky-atc-bar-enabled").
  var sticky = document.querySelector('div.sticky-atc-bar');
  if (!sticky) return;
  var stickyQty = sticky.querySelector('.quantity__input');
  var mainForm = document.querySelector('form.main-product-form') ||
    document.querySelector('product-info form[action*="/cart/add"], .product__info form[action*="/cart/add"]');
  var mainQty = null;
  if (mainForm) {
    mainQty = mainForm.querySelector('.quantity__input') ||
      (mainForm.id && document.querySelector('.quantity__input[form="' + mainForm.id + '"]'));
  }
  if (!mainQty) {
    var info = document.querySelector('.product__info-container');
    mainQty = info && info.querySelector('.quantity__input');
  }

  // a) the sticky bar always adds the quantity chosen in the buy box (volume cards set the main input)
  function syncQty() {
    if (!stickyQty || !mainQty) return;
    var q = parseInt(mainQty.value, 10);
    var min = parseInt(stickyQty.min || stickyQty.dataset.min, 10) || 1;
    if (q && q >= min) stickyQty.value = q;
  }
  if (mainQty) {
    ['input', 'change'].forEach(function (t) { mainQty.addEventListener(t, syncQty); });
    sticky.addEventListener('click', function (e) {
      if (e.target.closest('[type="submit"], [name="add"]')) syncQty();
    }, true);
    sticky.addEventListener('pointerenter', syncQty);
    sticky.addEventListener('focusin', syncQty);
  }

  // b) inc-VAT price follows the selected variant
  var priceBox = sticky.querySelector('.f-price');
  var incEl = sticky.querySelector('[data-price-inc-vat]');
  var exEl = sticky.querySelector('.f-price-item--sale') || sticky.querySelector('.f-price-item--regular');
  if (priceBox && incEl && exEl) {
    var rate = parseFloat(priceBox.getAttribute('data-vat-rate'));
    if (!(rate > 0)) rate = 20;
    if (rate > 1) rate = rate / 100;
    var updateInc = function () {
      var m = (exEl.textContent || '').replace(/,/g, '').match(/(\d+(?:\.\d+)?)/);
      if (!m) return;
      var inc = Math.round(parseFloat(m[1]) * (1 + rate) * 100) / 100;
      var txt = '£' + inc.toFixed(2);
      if (incEl.textContent !== txt) incEl.textContent = txt;
    };
    new MutationObserver(updateInc).observe(exEl, { childList: true, characterData: true, subtree: true });
    updateInc();
  }

  // c) hold the bar back until the shopper has scrolled past the main Add to cart button
  var mainBtn = mainForm && mainForm.querySelector('[name="add"], button[type="submit"]');
  if (mainBtn) {
    // Scroll check (not IntersectionObserver): a fast jump past the button never "intersects",
    // which left the bar hidden. Bar shows once the main button has scrolled above the viewport.
    var ticking = false;
    var update = function () {
      ticking = false;
      sticky.classList.toggle('ps-sticky-hold', mainBtn.getBoundingClientRect().bottom > 0);
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
})();
